jQuery(document).ready(function($) {
  let selectedCategories = [];
  let currentPage = 1; // Current page number
  let postsPerPage = 12; // Default number of posts to display per page

  // Define a function to update postsPerPage based on screen size
  // function updatePostsPerPage() {
  //   if (window.innerWidth <= 800) { 
  //     postsPerPage = 8;
  //   }
  //   if (window.innerWidth >= 800) { 
  //     postsPerPage = 8;
  //   }
  //   if (window.innerWidth >= 1200) { 
  //     postsPerPage = 12;
  //   }
  //   if (window.innerWidth >= 1800) { 
  //     postsPerPage = 16;
  //   }
  //   // When the postsPerPage value changes, re-filter the posts
  //   filterPosts();
  // }

  // // Call the updatePostsPerPage function initially
  // updatePostsPerPage();

  // // Bind the updatePostsPerPage function to the resize event
  // $(window).on('resize', updatePostsPerPage);



  $('.category-filter').on('click', function() {
    let category = $(this).data('category');
    toggleCategory(category);
  });

  if ($('.category-filter:checked').length > 0)  {     
    let checkedCategories = $('.category-filter:checked').data('category');

    toggleCategory(checkedCategories);
  }

  $('#ClearAll').on('click', function() {
    removeAllCategories();
  });

  $('.pagination').on('click', '.page-link', function(e) {
    e.preventDefault();
    currentPage = $(this).data('page');
    filterPosts();
  });

  filterPosts();

  function toggleCategory(category) {
    let index = selectedCategories.indexOf(category);
    if (index > -1) {
      selectedCategories.splice(index, 1); // Remove category if already selected
    } else {
      selectedCategories.push(category); // Add category to the array
    }
    currentPage = 1; // Reset to the first page when categories change
    filterPosts();
  }

  function removeAllCategories() {
    $('.category-filter:checked').prop('checked', false);
    selectedCategories = []; // Clear the selected categories array
    currentPage = 1; // Reset to the first page when categories are cleared
    filterPosts();
  }

  function filterPosts() {
    $.ajax({
      url: marthawhite.admin_url + 'admin-ajax.php',
      type: 'POST',
      data: {
        action: 'filter_posts',
        category: selectedCategories,
        page: currentPage, // Send the current page number to the server
        posts_per_page: postsPerPage // Send the number of posts per page to the server
      },
      success: function(response) {
        var posts = response.posts;
        var totalPosts = response.total_posts;
        $('.recipes-found').text(totalPosts + ' Recipes Found');

        if ($('#recipeFilterTarget').length) {
          $('#recipeFilterTarget').html(posts);
        } else {
          console.error("Target ID isn't found for the recipe filter. Check cat-filter.js success method");
        }

        updatePagination(totalPosts);
      }
    });
  }

  function updatePagination(totalPosts) {
    const totalPages = Math.ceil(totalPosts / postsPerPage);
    const paginationContainer = $('.pagination');
    let paginationHTML = '';
  
    if (totalPages > 1) {
      paginationHTML += '<ul class="pagination justify-content-center">';
      let startPage = Math.max(1, currentPage - 2); // Calculate the starting page
      let endPage = Math.min(totalPages, currentPage + 2); // Calculate the ending page
  
      // Previous page link
      if (currentPage > 1) {
        paginationHTML += '<li class="page-item"><a class="page-link" href="#" data-page="' + (currentPage - 1) + '"><img class="pagination-arrow-recipes" src="https://whitelilyqa1.wpengine.com/wp-content/uploads/2023/07/prev.png" alt="previous arrow"></a></li>';
      } else {
        paginationHTML += '<li class="page-item disabled"><a class="page-link" href="#"><img class="pagination-arrow-recipes" src="https://whitelilyqa1.wpengine.com/wp-content/uploads/2023/07/prev.png" alt="previous arrow"></a></li>';
      }
  
      // Page links
      for (let i = startPage; i <= endPage; i++) {
        if (i === currentPage) {
          paginationHTML += '<li class="page-item active"><span class="page-link">' + i + '</span></li>';
        } else {
          paginationHTML += '<li class="page-item"><a class="page-link" href="#" data-page="' + i + '">' + i + '</a></li>';
        }
      }
  
      // Next page link
      if (currentPage < totalPages) {
        paginationHTML += '<li class="page-item"><a class="page-link" href="#" data-page="' + (currentPage + 1) + '"><img class="pagination-arrow-recipes" src="https://whitelilyqa1.wpengine.com/wp-content/uploads/2023/07/next.png" alt="next arrow"></a></li>';
      } else {
        paginationHTML += '<li class="page-item disabled"><a class="page-link" href="#"><img class="pagination-arrow-recipes" src="https://whitelilyqa1.wpengine.com/wp-content/uploads/2023/07/next.png" alt="next arrow"></a></li>';
      }
  
      paginationHTML += '</ul>';
    }
  
    paginationContainer.html(paginationHTML);
  }
  
});
